import React, {useEffect, useRef} from 'react';
import dynamic from 'next/dynamic';
const Breadcrumbs = dynamic(() => import("../../components/breadcrumbs"));
const Card = dynamic(() => import("../../components/card"));
const CloseBtn = dynamic(() => import("../../components/close_btn"));
const Flowers = dynamic(() => import("../../components/flowers"));
import Link from 'next/link';
// import { useData } from '../../hooks/useData';
import sanityClient from "../../../public/support-func/sanityClient";
import { sortByDate } from '../../../public/support-func/support.js';
// сделать загрузку категорий при скролле
// import { createObserve } from '../services/animaion';
// import 'animate.css';

import Head from 'next/head';

export async function getStaticProps() {
  const pageMeta = await sanityClient.fetch(`*[_type == "metadata" && title == "/categories"] `);
  const pageData = await sanityClient.fetch(`*[_type == "stories" && active == true]`);
  const categories = await sanityClient.fetch(`*[_type == "categories" && activeCategory == true]`);

  return {
    props: { 
      pageMeta: pageMeta[0],
      pageData,
      categories
    },
    revalidate: 300
  };
};

const CategoriesPage = ({pageMeta, pageData, categories}) => {
  // const {getCategories, peronalsArray} = useData();
  const list = useRef<HTMLInputElement>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const handleOpenMenu = () => {
    list.current?.classList.add('categories__list--open');
  }

  const onClose = () => {
    list.current?.classList.remove('categories__list--open');
  }

  useEffect(() => {
    // createObserve(document.querySelectorAll('.story_cards'), 'animate__fadeInDown')

    document.querySelector('.flower_container_two')?.classList.add('none');
    document.querySelector('.flower_container_three')?.classList.add('none');
  }, [])

    return (
        <>
        <Head>
          <title>{ pageMeta.meta_title }</title>
          <meta name="description" content={pageMeta.meta_description} />
          <meta name="keywords" content={pageMeta.meta_keywords} />
        </Head>
        <Breadcrumbs pathArr={[{name: "Категории", url: "/categories",}]} />
        <Flowers />
          <button className='btn_no_bg btn--margin_top accent_text' onClick={handleOpenMenu}>Список категорий</button>
          <div className='categories__list' ref={list}>
            <div className='modal_top_close'>
              <CloseBtn clickHandler={onClose} />
            </div>

            {categories?.map((item: any, i: number) => {
                return <p key={item._id}>
                  <Link href={`/categories/${item.slug.current}`} >
                    {item.title}
                  </Link>
                </p>
              })}
          </div>
          <h1 className='accent_text'>Все категории</h1>
          {categories?.map((item: any, i: number) => {
            return <section className='section' key={item._id + 'categorySection'}>
                    <div className='flexbox-rows space-between'>
                      <h2 className="h2">{item.title}</h2>
                      <Link className='h4 accent_text' href={`/categories/${item.slug.current}`}>Перейти в категорию</Link>
                    </div>
                    
                    <div className='story_cards'>
                        {sortByDate(pageData)?.filter((point: any) => point.category._ref === item._id)?.slice(0, 3)
                          .map((item: any, i: number) => {
                          return <Card 
                            key={item._id}
                            title={item.title}
                            text={item.shortDescription}
                            linkToStory={`/stories/${item.slug.current}`}
                          />
                      })}
                    </div>
                  </section>
          })}
        </>
    )
}

export default CategoriesPage;